import { LazyImage } from '@ui/common/lazy-image.tsx';
import { Link } from '@heroui/react';

export const DesktopFooter = () => {
  return (
    <div className="bg-[#F8F9FA]">
      <div className="container max-w-7xl mx-auto flex flex-row py-24">
        <div className="flex-grow max-w-[440px] flex-shrink-0">
          <div className="w-80 h-24">
            <LazyImage src="/color_logo.svg" fit="contain" />
          </div>
        </div>

        <div className="grid grid-cols-3 flex-grow">
          <div className="flex flex-col gap-y-6">
            <p className="text-xl font-semibold text-[#222222]">Компания</p>
            <Link href="/about" className="text-[#60656C]">
              О компании
            </Link>

            <Link href="/contacts" className="text-[#60656C]">
              Служба поддержки
            </Link>
          </div>

          <div className="flex flex-col gap-y-6">
            <p className="text-xl font-semibold text-[#222222]">
              Правила и условия
            </p>
            <Link href="/privacy-of-policy" className="text-[#60656C]">
              Политика конфиденциальности
            </Link>

            <Link href="/terms" className="text-[#60656C]">
              Правила пользования
            </Link>
          </div>

          <div className="flex flex-col gap-y-6">
            <p className="text-xl font-semibold text-[#222222]">Контакты</p>
            <Link
              href="/about"
              className="text-[#60656C] flex flex-row gap-x-3"
            >
              <div className="w-6 h-6 flex-shrink-0">
                <LazyImage src="/mail_icon.svg" />
              </div>
              zerdepharma.account@yandex.kz
            </Link>

            <Link
              href="/contacts"
              className="text-[#60656C] flex flex-row gap-x-3"
            >
              <div className="w-6 h-6 flex-shrink-0">
                <LazyImage src="/call_icon.svg" />
              </div>
              +7 (701) 777 67 70
            </Link>

            <Link
              href="/contacts"
              className="text-[#60656C] flex flex-row gap-x-3"
            >
              <div className="w-6 h-6 flex-shrink-0">
                <LazyImage src="/whatsapp_icon.svg" />
              </div>
              Написать в WhatsApp
            </Link>
          </div>
        </div>
      </div>
      <div className="text-center py-6 text-sm text-[#222222] border-t">
        ТОО “ZERDE” © Все права защищены. 2025
      </div>
    </div>
  );
};
